import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useAudioOptions } from "@/pages/PlayerPage/lib/useAudioOptions";
import { InputRange } from "@/shared/ui/InputRange";
import { useData } from "@/pages/PlayerPage/lib/useData";
import { VideoPlayer } from "@/pages/PlayerPage/ui/VideoPlayer";
import { observer } from "mobx-react-lite";
import { useVideoSegments } from "@/pages/PlayerPage/lib/useVideoSegmants";
import { usePlayerStore } from "@/features/player/lib/usePlayerStore";

type AudioOption = {
    label: string;
    url: string;
};

type StreamPlayerProps = {
    videoSrc: string;
    audioOptions: AudioOption[]; // список доступных аудиотреков
};
const audioUrl =
    "https://fastapi.dev.torsunov.pro/download_rus?file_name=01ba5e1e28b1449bbc71d7ef98a3fed0/files_to_send/1.mp3";

export const Main: React.FC = observer(() => {
    const audioRef = useRef<HTMLAudioElement>(null);
    const store = usePlayerStore();

    const [videoVolume, setVideoVolume] = useState(1);
    const [selectLang, setSelectLang] = useState("");

    const { lang } = useParams();

    useEffect(() => {
        if (lang) {
            setSelectLang(lang);
        }
    }, [lang]);

    useEffect(() => {}, [store.quality]);

    const { audioUrl } = useData({
        mediaId: "3de70c09848148c58d15b788beb843e3",
        lang: selectLang,
    });

    const { videoUrls, subtitles } = useVideoSegments({
        mediaId: "3de70c09848148c58d15b788beb843e3",
        lang: selectLang,
    });

    const { audioOptions, isAudioLoaded, audioFile } = useAudioOptions({
        audioUrl,
        lang: selectLang,
    });

    const handlePlay = () => {
        const audio = audioRef.current;
        if (audio && audioFile && isAudioLoaded) {
            audio.play().catch((err) => {
                console.warn("Аудио не запущено:", err);
            });
        }
    };

    const handlePause = () => {
        const audio = audioRef.current;
        if (audio && audioFile && isAudioLoaded) {
            audio.pause();
        }
    };

    return (
        <div className="">
            <VideoPlayer
                audioRef={audioRef}
                audioFile={audioFile}
                videoVolume={videoVolume}
                onPlay={handlePlay}
                onPause={handlePause}
                subtitles={subtitles}
                selectLang={selectLang}
                setSelectLang={setSelectLang}
                videoUrls={videoUrls}
            />
            {audioUrl && (
                <audio
                    ref={audioRef}
                    src={audioFile || undefined}
                    preload="auto"
                />
            )}
        </div>
    );
});
